import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const createBranch = createAsyncThunk(
    'createBranchForm/createBranch',
    async ({newBranch, token}) => {
        const requestBody = JSON.stringify(newBranch);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/branches/create`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const createBranchFormSlice = createSlice({
    name: 'createBranchForm',
    initialState: {
        branchName: '',
        active: false,
        creatingNewBranch: false,
        confirmingCreateBranch: false,
        failedToCreateNewBranch: false,
        status: '',
        createdBranch: {}
    },
    reducers: {
        changeBranchName: (state, action) => {
            return {
                ...state,
                branchName: action.payload
            }
        },
        toggleCreateBranchForm: (state) => {
            return {
                ...state,
                active: !state.active,
                status: ''
            }
        },
        clearCreateBranchForm: (state) => {
            return {
                ...state,
                branchName: '',
            }
        },
        changeCreateBranchFormStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        },
        setCreateBranchConfirming: (state, action) => {
            return {
                ...state,
                confirmingCreateBranch: action.payload
            }
        }
    },
    extraReducers: {
        [createBranch.pending]: (state) => {
            return {
                ...state,
                creatingNewBranch: true,
                failedToCreateNewBranch: false
            }
        },
        [createBranch.fulfilled]: (state, action) => {
            return {
                ...state,
                creatingNewBranch: false,
                failedToCreateNewBranch: false,
                status: action.payload.id ? "Branch successfully created" : "Branch already exists",
                createdBranch: action.payload
            }
        },
        [createBranch.rejected]: (state) => {
            return {
                ...state,
                creatingNewBranch: false,
                failedToCreateNewBranch: true
            }
        }
    }
})

export const selectBranchName = (state) => state.createBranchForm.branchName;
export const createBranchFormIsActive = (state) => state.createBranchForm.active;
export const selectConfirmingCreateBranch = (state) => state.createBranchForm.confirmingCreateBranch;
export const creatingNewBranch = (state) => state.createBranchForm.creatingNewBranch;
export const failedToCreateNewBranch = (state) => state.createBranchForm.failedToCreateNewBranch;
export const selectCreateBranchFormStatus = (state) => state.createBranchForm.status;
export const selectCreatedBranch = (state) => state.createBranchForm.createdBranch;

export const { changeBranchName, toggleCreateBranchForm, clearCreateBranchForm, changeCreateBranchFormStatus, setCreateBranchConfirming } = createBranchFormSlice.actions;

export default createBranchFormSlice.reducer;